import Typography from '@eduzz/houston-ui/Typography';
import { Grid } from '@material-ui/core';
import makeStyles from '@material-ui/core/styles/makeStyles';
import React from 'react';
import { useObservable } from 'react-use-observable';
import leadsService from 'v2/services/leads/list';
import tableService from 'v2/services/table';

import Export from '../Export';

const useStyle = makeStyles((theme) => ({
  root: {
    marginBottom: theme.spacing(1),
    textAlign: 'center',
  },
  '@media screen and (min-width: 600px)': {
    root: {
      background: '#ffff',
      borderRadius: 4,
      boxShadow: '0 1px 0 0 rgba(0,0,0,0.07)',
      width: '100%',
      marginBottom: theme.spacing(2),
    },
  },
  totalItems: {
    paddingLeft: theme.spacing(2),
  },
}));

const Details = () => {
  const classes = useStyle({});

  const [totalItems] = useObservable(() => leadsService.getTotalItems(), []);
  const [loading] = useObservable(() => tableService.isLoading(), []);

  if (loading) return null;

  return (
    <Grid className={classes.root} id='leads-details' container direction='row' justify='space-between' alignItems='center'>
      <Grid item>
        <Typography className={classes.totalItems} id='leads-result-button-label' weight='semibold' data-testid='leads-result-label'>
          {totalItems} leads
        </Typography>
      </Grid>
      <Grid>
        <Export />
      </Grid>
    </Grid>
  );
};

export default Details;
